<template>
  <el-row
    class="project-show-container wow animate__slideInUp"
    data-wow-duration="800ms"
  >
    <el-col :span="8">
      <div class="left-box">
        <div class="header">
          <p class="name">{{ data.name }}</p>
          <p class="name" v-if="data.label">{{ data.label }}</p>
          <p class="title">{{ data.title }}</p>
          <div class="desc" :class="[data.label && 'desc-spe']">
            <p
              v-for="(item, index) in data.desc || []"
              :key="index"
              v-html="item"
            ></p>
          </div>
        </div>
        <div class="footer">
          <div class="footer-header">
            <div class="button" v-show="data.link" @click="goPage(data.link)">
              <p>立即探索</p>
            </div>
            <span class="city">
              {{ data.city }}
            </span>
          </div>
          <p
            v-for="(item, index) in data.footer || []"
            :key="index"
            v-html="item"
          ></p>
        </div>
      </div>
    </el-col>
    <el-col :span="16">
      <div class="right-box">
        <div ref="headerSwiperRef" class="swiper-box">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in data.images"
              :key="index"
            >
              <img
                :src="`${item}`"
                alt="轮播图"
                style="width: 100%; cursor: pointer"
              />
            </div>
          </div>
        </div>
        <div class="swiper-button-prev" ref="prevRef"></div>
        <div class="swiper-button-next" ref="nextRef"></div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  name: "ProjectShow",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    goPage(url) {
      url && window.open(url, "_blank");
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();

      this.swiper = new Swiper(this.$refs.headerSwiperRef, {
        loop: true,
        navigation: {
          nextEl: this.$refs.nextRef,
          prevEl: this.$refs.prevRef,
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
        },
        speed: 1000,
        grabCursor: true,
        centerInsufficientSlides: true,
      });
    });
  },
  beforeDestroy() {
    this.swiper = null;
  },
};
</script>
<style lang="scss" scoped>
.project-show-container {
  padding-top: 30px;
  .left-box {
    position: relative;
    background-color: #f3f3f4;
    height: 630px;
    padding: 50px 20px 50px 50px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .header {
      flex: 1;
    }

    .name {
      font-size: 28px;
      color: #008048;
    }

    .title {
      color: #008048;
      margin-top: 10px;
      line-height: 30px;
      font-size: 18px;
    }

    .desc {
      font-size: 13px;
      color: #565c61;
      text-align: justify;
      line-height: 24px;
      margin-top: 70px;
      &.desc-spe {
        margin-top: 40px;
      }
    }

    .footer {
      text-align: justify;
      font-size: 14px;
      color: #565c61;
      line-height: 28px;
      flex-shrink: 0;

      .footer-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 41px;
      }

      .button {
        background: #f3f3f4;
        width: 85px;
        height: 30px;
        border: 1px solid #565c61;
        outline: none;
        color: #565c61;
        font-size: 13px;
        line-height: 30px;
        font-weight: 400;
        border-radius: 1px;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        text-align: center;
        position: relative;

        &::before {
          content: "";
          width: 0;
          height: 100%;
          transition: all 0.3s ease-in-out;
          background-color: #565c61;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
        }

        &:hover {
          > p {
            color: #fff;
            z-index: 2;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }
          &::before {
            width: 100%;
          }
        }
      }
    }
  }

  .right-box {
    background-color: #f9f9f9;
    width: 100%;
    box-sizing: border-box;
    padding: 50px;
    height: 630px;
    overflow: hidden;
    position: relative;
    .swiper-wrap {
      width: 100%;
    }
  }

  .swiper-box {
    overflow: hidden;
    height: 100%;
  }

  .swiper-slide {
    overflow: hidden;
    background-color: #f9f9f9;
    height: 100%;
    > img {
      position: absolute;
      height: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  ::v-deep {
    .swiper-button-next,
    .swiper-button-prev {
      color: #000;
      &:hover {
        color: #00803e;
      }
    }
  }
}
</style>
